import { render, staticRenderFns } from "./StockTransfers.vue?vue&type=template&id=4c46ffec&"
import script from "./StockTransfers.vue?vue&type=script&lang=js&"
export * from "./StockTransfers.vue?vue&type=script&lang=js&"
import style0 from "./StockTransfers.vue?vue&type=style&index=0&id=4c46ffec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports